export default "__VITE_ASSET__BykLbolY__"